var _desc, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcChecked(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18px",
    height: "18px",
    viewBox: "0 0 18 18",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "ic_checked") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Role-Manage-Web-App",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Role-:-Add-Member",
    transform: "translate(-573.000000, -364.000000)",
    fill: "#97B041",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Members-Lists-Copy",
    transform: "translate(257.000000, 342.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "btn-default-copy",
    transform: "translate(285.000000, 13.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "btn-default"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Button/Primary"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ic_checked",
    transform: "translate(31.000000, 9.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18,9 C18,4.02943076 13.9705692,0 9,0 C4.02943076,0 0,4.02943076 0,9 C0,13.9705692 4.02943076,18 9,18 C13.9705692,18 18,13.9705692 18,9 Z M7.95899225,13.7654439 C7.73221317,13.9921521 7.36456102,13.9921521 7.13778194,13.7654084 L3.36358839,9.99121488 C3.1368802,9.76447124 3.1368802,9.39678364 3.36358839,9.17004001 L4.18476326,8.34890058 C4.4115069,8.12215694 4.77919449,8.12215694 5.00593813,8.34890058 L7.5483871,10.891385 L12.9940619,5.44571021 C13.2208409,5.21893114 13.5885285,5.21893114 13.8152367,5.44571021 L14.6364116,6.26684964 C14.8631198,6.49359328 14.8631198,6.86128087 14.6364116,7.08802451 L7.95899225,13.7654439 Z"
  }))))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcChecked);
export default __webpack_public_path__ + "static/media/ic_checked.b033927c3050d3be954981bac02b7151.svg";
export { ForwardRef as ReactComponent };